import { BrowserHttpClient } from '@/services/Http/BrowserHttpClient';
import { AbstractStatesScheduler } from '@/services/UserActivity/AbstractStatesScheduler';
import { logger } from '@/utils/logger/logger';

class SavedStatesScheduler extends AbstractStatesScheduler<boolean> {
    private static instance: SavedStatesScheduler;
    public static CHANGE_EVENT = 'savedState:change';

    private constructor() {
        super();
    }

    public static getInstance(): SavedStatesScheduler {
        if (!SavedStatesScheduler.instance) {
            SavedStatesScheduler.instance = new SavedStatesScheduler();
        }
        return SavedStatesScheduler.instance;
    }

    protected async fetchStates(keys: string[]): Promise<string[]> {
        try {
            const response: Record<string, boolean> = await new BrowserHttpClient().post({
                path: '/activity/saved_states',
                body: { keys },
            });

            // Update the states map and notify subscribers
            if (response) {
                Object.entries(response).forEach(([key, state]) => {
                    this.states.set(key, state);
                    this.notifySubscribers(key, state);
                });
            }
            return [];
        } catch (error) {
            logger.error('Failed to fetch saved states:', error);
            return keys;
        }
    }

    protected getChangedEventName(): string {
        return SavedStatesScheduler.CHANGE_EVENT;
    }
}

export default SavedStatesScheduler;
